import { NETWORK_APEX_DOMAIN } from "@framework/config";
import { UserPromotion } from "@voxmedia/duet-context/context/auth-context";
import { getCookie } from "@voxmedia/duet-utils/cookie";

/*
  Retrieves experiment IDs and variants from the google optimize cookie
*/
export const getGoogleOptimizeCookie = (): Record<string, any> | null => {
  const googleOptimizeCookie = getCookie("_gaexp");
  const googleOptimizeExperimentIds = googleOptimizeCookie.split(".");
  if (googleOptimizeCookie.length === 0) {
    return null;
  }

  const experimentIDs: Array<string> = [];
  const experimentVariants: Array<string> = [];
  googleOptimizeExperimentIds.forEach((id, index) => {
    if (index <= 1) {
      return;
    }

    // Google Optimize Expirement IDs are 22 in length and Variants are 1.
    // Based on code in SBN: https://github.com/voxmedia/sbn/pull/12234
    if (id.length === 22) {
      experimentIDs.push(id);
    } else if (id.length === 1) {
      experimentVariants.push(id);
    }
  });

  return {
    "Google Optimize Experiment ID": experimentIDs.join(","),
    "Google Optimize Experiment Variant": experimentVariants.join(","),
  };
};

export const getCommunityCode = (
  communityName: string,
  communityCanonicalDomain: string,
  isPrimaryCommunity: boolean,
): string => {
  return isPrimaryCommunity
    ? communityName.toLowerCase().replace(/ /g, "")
    : communityCanonicalDomain.replace(".com", "").replace("www.", "");
};

/**
 * Filters user promotions by community domain and formats them as a comma-separated string.
 * @param promotions - The user's promotions array
 * @returns Comma-separated string of "promotionId:status" pairs, or undefined if no matching promotions
 */
export const getMembershipPromotions = (
  promotions?: UserPromotion[],
): string | undefined => {
  const filtered = promotions?.filter(
    (promotion) => promotion.network === NETWORK_APEX_DOMAIN,
  );

  if (!filtered || filtered.length === 0) {
    return undefined;
  }

  return filtered
    .map((promotion) => `${promotion.promotionId}:${promotion.status}`)
    .join(",");
};
